import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUnsubscribeMyContentCommentSubscriptions } from 'actions/contentCommentSubscriptions';
import SimpleModal from 'components/SimpleModal';
function UnsubscribeConfirmationModal(_ref) {
  var closeModal = _ref.closeModal;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useUnsubscribeMyCont = useUnsubscribeMyContentCommentSubscriptions({
      onSuccess: closeModal
    }),
    unsubscribeMyContentCommentSubscriptions = _useUnsubscribeMyCont.unsubscribeMyContentCommentSubscriptions,
    isLoading = _useUnsubscribeMyCont.isLoading;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    width: "wide",
    title: t('modal_unsubscribe_content_comments_title'),
    body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, t('modal_unsubscribe_content_comments_body_1')), /*#__PURE__*/React.createElement("p", null, t('modal_unsubscribe_content_comments_body_2'))),
    buttons: [{
      label: t('actions_cancel'),
      onClick: closeModal,
      isDisabled: isLoading
    }, {
      label: t('actions_confirm'),
      onClick: function onClick() {
        return unsubscribeMyContentCommentSubscriptions();
      },
      variant: 'primary',
      isDisabled: isLoading
    }],
    onClose: closeModal
  });
}
export default UnsubscribeConfirmationModal;